import { render, staticRenderFns } from "./DataPelanggaran.vue?vue&type=template&id=3bb009de&scoped=true"
import script from "./DataPelanggaran.vue?vue&type=script&lang=js"
export * from "./DataPelanggaran.vue?vue&type=script&lang=js"
import style0 from "./DataPelanggaran.vue?vue&type=style&index=0&id=3bb009de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb009de",
  null
  
)

export default component.exports